import Base from './Base';
import Helper from '../Helper';
import Product from '../../Stores/Product';
import WidgetsInput from '../../Components/Widgets/Input.svelte';
import {get} from 'svelte/store';

export default class Info extends Base {
	build(list, property, active) {
		const host = this;
		const selected = property.selected || {};
		const state = !Helper.undefined(selected.value) ? (selected.valid ? 'success' : 'error') : '';
		const component = {
			component: WidgetsInput,
			config: {
				active, state,
				type: 'text',
				value: selected.value || null,
				label: property.name,
				unit: property.unit,
				required: !!property.required,
				description: property.description,
				on_change: item => {
					Product.setProperty(property);
					property.selected = item;
					const wait = !!property.group;
					this.update(wait);
				}
			}
		};

		list.push(component);
		return list;
	}
}